var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.517 21.495a1.696 1.696 0 0 1 0-2.438L14.74 12 7.517 4.943a1.696 1.696 0 0 1 0-2.438 1.794 1.794 0 0 1 2.495 0l8.471 8.276c.69.673.69 1.765 0 2.438l-8.47 8.276a1.794 1.794 0 0 1-2.496 0",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;